import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './FormComponent.css'; // 👈 Import the CSS

const SERVICE_ID = 'service_en8mqa6';
const TEMPLATE_ID = 'template_6zaz49t';
const PUBLIC_KEY = 'NZmf8CkWyk_KhVEt-';

function FormComponent() {
  const [formData, setFormData] = useState({
    fullName: '',
    course: '',
    address: '',
    phone: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs.send(SERVICE_ID, TEMPLATE_ID, formData, PUBLIC_KEY)
      .then(() => {
        alert("Thanks! Your details have been submitted.");
        setFormData({ fullName: '', course: '', address: '', phone: '' });
      })
      .catch((err) => {
        console.error("FAILED...", err);
        alert("Oops! Something went wrong.");
      });
  };

  return (
    <div className="form-container">
      <h2>Career Counseling</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Full Name</label>
          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Course</label>
          <input
            type="text"
            name="course"
            value={formData.course}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Address</label>
          <textarea
            name="address"
            rows="3"
            value={formData.address}
            onChange={handleChange}
            required
          ></textarea>
        </div>
        <div className="form-group">
          <label>Phone Number</label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit">Submit</button>
      </form>
    </div>
  );
}

export default FormComponent;
